import parse from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';

const ALLOWED_TAGS = ['span'];
const ALLOWED_ATTRIBUTES = {
  span: ['lang'],
};

export function parseHTML(value: string) {
  return parse(
    sanitizeHtml(value, {
      allowedTags: ALLOWED_TAGS,
      allowedAttributes: ALLOWED_ATTRIBUTES,
    }),
  );
}
